var map = {
	"./invoice/invoice.module": "./src/app/invoice/invoice.module.ts",
	"./item/item.module": "./src/app/item/item.module.ts",
	"./report/report.module": "./src/app/report/report.module.ts",
	"./settings/settings.module": "./src/app/settings/settings.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;